import { z } from "zod";

export const formSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email address" }),
  orgId: z.string().optional(),
  role: z.string().min(1, { message: "Please select a role" })
});
